import Page from 'components/Page';
import React from 'react';
import {Button, ButtonGroup, Card, CardBody, Col, Row, Table,} from 'reactstrap';
import BasePage from './BasePage';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {MdEdit} from 'react-icons/md';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import SearchInput from '../components/SearchInput';
import {deleteParam, parseDate} from '../utils/Utilities';
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import {AuthConsumer} from '../utils/AuthContext';
import Img from 'react-image';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import DropdownInput from "../components/form/DropdownInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";


const tableTypes = ['', 'bordered', 'striped', 'hover'];

class AdminPage extends BasePage{


    constructor(props) {
        super(props);
        this.state ={
            admins : [],
            admin:{},
            modalDeleteConfirm:false,
            ascending:true,
            sortir:'created',
            search:"",
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            totalPage:0,
            totalElement:0,
            pageElement:0,

        }
    }

    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props){
            this.setState({
                page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
            }, () => {
                this.fetchAll(this.state.ascending, this.state.sortir, this.state.search,true)
            })
        }
    }


    componentDidMount() {
        super.componentDidMount();
        this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, true)
    }

    fetchAll = (ascending, sortir, search, progressing) => {
        let {page} = this.state
        this.get(Global.API.ADMINS, {
            params:{
                ascending:ascending,
                sortir:sortir,
                search:search,
                page:page-1
            }
        }, null, res=>{
            if(res.code === 200){
                this.setState({
                    admins : res.data,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        }, progressing, true);
    }

    confirmDelete = () =>{
        this.setState({
            modalDeleteConfirm:true
        })
    }

    delete = () => {
        this.setState({
            modalDeleteConfirm:false
        }, () => {
            this.get(Global.API.ADMIN_DELETE+"/"+this.state.admin.id, null, null, res => {
                if(res.code===200){
                    this.setState({
                        category:null
                    }, () => {
                        this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, true)
                    })
                }
            }, true, true);
        })
    }

    closeDialog = () =>{
        this.setState({
            modalAddConfirm:false,
            modalDeleteConfirm:false
        })
    }

    refreshAdmin = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir
        }, () => {
            this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, progressing)
        })
    )


    render() {
        var i = 0 ;
        let {ascending, sortir} = this.state
        let orderOptions = delegateObjectsForSelection(
            {name:label.Name, field:'firstname'},
            {name:label.Created, field:'created'},
            {name:label.Updated, field:'updated'}
        )
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})


        return (
            <AuthConsumer>
                {({admin, logout, login})=>(
                    <Page
                        title={label.Administrator}
                        breadcrumbs={[{ name: label.Administrator, active: true }]}
                        className="TablePage">
                        {super.render()}
                        <ConfirmDialog
                            showing={this.state.modalDeleteConfirm}
                            title={label.DeleteConfirmationTitle}
                            message="Do you want to delete this admin item from your list ?"
                            okCallback={this.delete}
                            cancelCallback={this.closeDialog}/>
                        <Row key={1}>
                            <Col>
                                <Card className="mb-6">
                                    <PrimaryCardHeader content={label.Administrator}/>
                                    <CardBody>
                                        <Row>
                                            <Col md={6}>
                                                <ButtonGroup className="d-flex w-100">
                                                    <DropdownInput
                                                        title={label.SortBy}
                                                        options={orderOptions}
                                                        onSelect={(item) => {
                                                            this.refreshAdmin(ascending, item.field, true)
                                                        }}
                                                        onReset={() => {
                                                            this.refreshAdmin(ascending, "created", true)
                                                        }}/>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <DropdownInput
                                                        options={ascendingOptions}
                                                        onSelect={(item) => {
                                                            this.refreshAdmin(item.field, sortir, true)
                                                        }}
                                                        onReset={() => {
                                                            this.refreshAdmin(true, sortir, true)
                                                        }}/>
                                                </ButtonGroup>
                                            </Col>
                                            <Col md={4}>
                                                <SearchInput
                                                    placeholder={"Search admin name..."}
                                                    value={this.state.search}
                                                    onChange={e=>{
                                                        this.setState({
                                                            search:e.target.value
                                                        }, () => {
                                                            if(this.state.search===''){
                                                                deleteParam(this.props, 'page')
                                                            }
                                                        })
                                                    }}
                                                    onEnter={e=>{
                                                        if(this.state.search!==''){
                                                            deleteParam(this.props, 'page')
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col md={2}>
                                                <ButtonGroup className="float-right">
                                                    <Button color="primary" onClick={e=>{
                                                        this.props.history.push('/adminDetail')
                                                    }}>{label.CreateNewAdmin}</Button>
                                                </ButtonGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Table responsive hover>
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>{label.Fullname}</th>
                                                    <th>{label.Email}</th>
                                                    <th>{label.Role}</th>
                                                    <th>{label.Status}</th>
                                                    <th>{label.Image}</th>
                                                    <th>{label.Updated}</th>
                                                    <th>{label.Edit}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    this.state.admins.map((item, index)=>(
                                                        <tr key={item.id}>
                                                            <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                                            <td>{item.firstname+" "+(item.lastname!=null?item.lastname:"")}</td>
                                                            <td>{item.email}</td>
                                                            <td>{item.role.name}</td>
                                                            <td>{item.adminStatus}</td>
                                                            <td width="5%">{
                                                                item.image!=undefined?
                                                                    <Img
                                                                        className="img-thumbnail"
                                                                        src={item.imageLink}
                                                                        onClick={e=>{
                                                                            this.setState({
                                                                                imageLink:item.imageLink,
                                                                                openPreview:true
                                                                            })
                                                                        }}
                                                                    />
                                                                    :
                                                                    "-"
                                                            }</td>
                                                            <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                                            <td>
                                                                {
                                                                    admin.id!=item.id&&(
                                                                        <Button size="sm" color="primary" onClick={ e => (
                                                                            this.props.history.push('/adminDetail?id='+item.id)
                                                                        )}>
                                                                            <MdEdit/>
                                                                        </Button>
                                                                    )
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </CardBody>
                                    <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
                                </Card>
                            </Col>
                        </Row>
                    </Page>
                )}
            </AuthConsumer>
        );
    }
}
export default Object.assign(AdminPage, {ENDPOINT : "/admins"})
